/* =========================================================
	TEAM INTERACTIONS
	Provides interactions for people listing on
	team/our people page.

	Modified from original script by
	previous developer / Serenity.
========================================================= */
document.querySelectorAll('.person').forEach(function(person) {
	person.addEventListener('click', function() {
		document.querySelectorAll('.person').forEach(function(person) {
			person.classList.remove('active');
		});
		person.classList.add('active');
		loadBio(person);
	}, false);
});

function loadBio(person) {
	let bioRow = document.querySelector('.bio-row');

	if (bioRow === null) {
		bioRow = createRow();
	}

	let parentGrid = person.closest('.people-grid');
	let allPeople = parentGrid.querySelectorAll('.person-outer');
	let allPeopleArray = Array.from(allPeople);
	let personEl = person.closest('.person-outer');
	let personNumber = allPeopleArray.indexOf(personEl);

	let peoplePerRow;
	let windowWidth = window.innerWidth;
	if (windowWidth > 1200) {
		peoplePerRow = 5;
	} else if (windowWidth > 900) {
		peoplePerRow = 4;
	} else if (windowWidth > 700) {
		peoplePerRow = 3;
	} else if (windowWidth > 500) {
		peoplePerRow = 2;
	} else {
		peoplePerRow = 1;
	}

	let insertAfterPersonNumber = personNumber + (peoplePerRow - ((personNumber) % peoplePerRow)) - 1;

	if (insertAfterPersonNumber >= allPeopleArray.length) {
		insertAfterPersonNumber = allPeopleArray.length - 1;
	}

	let personToInsertAfter = allPeopleArray[insertAfterPersonNumber];
	personToInsertAfter.after(bioRow);

	bioRow.classList.add('showing-bio');
	let bio = person.querySelector('.bio.sr-only');

	let bioText = 'Hi!';
	if (typeof(bio) != 'undefined' && bio != null) {
		bioText = bio.innerHTML;
	}

	let bioCol = bioRow.querySelector('.container .prose');
	bioCol.innerHTML = bioText;

	// Add the event listener to the close button
	let closeButton = bioRow.querySelector('button');
	closeButton.addEventListener('click', function() {
		bioRow.classList.remove('showing-bio');
		document.querySelectorAll('.person').forEach(function(person) {
			person.classList.remove('active');
		});
	});
}

function createRow() {
	let row = document.createElement('div');
	row.className = 'full-width bio-row';

	let outerDiv = document.createElement('div');
	outerDiv.className = 'inner-container';

	let innerDiv = document.createElement('div');
	innerDiv.className = 'container';

	let text = document.createElement('div');
	text.className = 'prose';

	let close = document.createElement('button');
	close.innerHTML = `
		<svg xmlns="http://www.w3.org/2000/svg" width="48.535" height="48.535" viewBox="0 0 48.535 48.535">
			<g id="Group_959" data-name="Group 959" transform="translate(-1449.439 -1607.439)">
				<line id="Line_76" data-name="Line 76" x2="46.414" y2="46.414" transform="translate(1450.5 1608.5)" fill="none" stroke="#e0684a" stroke-width="3"/>
				<line id="Line_77" data-name="Line 77" x2="46.414" y2="46.414" transform="translate(1496.914 1608.5) rotate(90)" fill="none" stroke="#e0684a" stroke-width="3"/>
			</g>
		</svg>`;

	outerDiv.append(innerDiv);
	innerDiv.append(text);
	innerDiv.append(close);
	row.append(outerDiv);

	return row;
}